import React, { useState, useMemo, useEffect } from 'react'
import IPButton from '../../../../../components/IPButton'
import Translations from '../../../../../translations'
import { translate } from '../../../../../base/localization'
import IPSelectBox, { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { useCustomReducer } from '../../../../../base/customHooks'
import InputCampaign from '../../../../../components/InputCampaign'
import IPInput from '../../../../../components/IPInput'
import Table from '../../../../../components/Table'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import Swal from 'sweetalert2'
import { ICancelPosRequest, ISuccessFullRequest, ISuccessFullResponse } from '../models/models'
import { exportToXLSX, getDateByTimezoneOffset } from '../../../../../base/utils/dataHelper'
import { GetSuccessFullApi } from '../services/getSuccessFullApi'
import moment from 'moment'
import { OrderPermApi } from '../../BIN/services/orderPermApi'
import IPModal from '../../../../../components/IPModal'
import { ICardNumberRequest, ICardNumberResponse } from '../../BIN/models/models'
import { OrderDetailApi } from '../../BIN/services/orderDetailApi'
import { CreateReceiptApi } from '../../SAP/services/createReceiptApi'
import { CreateReceiptFromSuccessApi } from '../services/createReceiptFromSuccessApi'
import { CancelPosApi } from '../services/cancelPosApi'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { getCompanyApi } from '../../../components/api'
import { ICompany } from '../../../components/models/models'

interface ISuccessfullState {
  successfulData: ISuccessFullResponse[]
  dealerCode: string
  tkyNumber: string
  companyListOptions: ISelectOption[]
  typeOptions: ISelectOption[]
  companyListOption: any
  typeOption: any
  companyListFirstOption: any
  additionalFilter: boolean
  vodafoneFilterCheckbox: boolean
  cancelFilterCheckbox: boolean
  posFilterOption?: ISelectOption | null
  posFilterOptions: ISelectOption[]
  mtOptions: ISelectOption[]
  mtOption: any
  orderBool?: boolean
  orderShow: boolean
  orderDetail?: ICardNumberResponse
  detailTKY?: string
  detailDealer?: string
  currencyOptions: ISelectOption[]
  currencyOption: any
  threeDOptions: ISelectOption[]
  threeDOption: any
  imeiFilter: string
  pkInvoiceStatusOption: any
  pkInvoiceStatusOptions: ISelectOption[]
}

interface IPosData {
  Id: number
  Name: string
}

class ListPosDataApi extends ClientProxy {
  constructor() {
    super({
      url: 'admin/posTransaction/listPosData',
      requesterInfo: {},
    })
  }

  public async listPosData(): Promise<IPosData[]> {
    return await this.getAsync<IPosData[]>()
  }
}

function Successful(props: BaseComponentWithContextProps) {
  const t = translate(Translations)
  const getInitialState = (): ISuccessfullState => {
    return {
      successfulData: [],
      dealerCode: '',
      tkyNumber: '',
      additionalFilter: false,
      vodafoneFilterCheckbox: false,
      cancelFilterCheckbox: false,
      posFilterOption: null,
      posFilterOptions: [],
      orderShow: false,
      companyListOption: null,
      companyListFirstOption: null,
      typeOption: null,
      companyListOptions: [],
      typeOptions: [
        { label: 'Cari Ödeme', value: 'CariOdeme' },
        { label: 'Avantaj', value: 'Avantaj' },
        { label: 'Fırsat', value: 'Firsat' },
        { label: 'FÇV', value: 'FCV2' },
      ],
      mtOption: null,
      mtOptions: [
        { label: 'Personel', value: 1 },
        { label: 'Bayi', value: 2 },
      ],
      currencyOption: null,
      currencyOptions: [
        { label: 'TL', value: 'TL' },
        { label: 'USD', value: 'USD' },
        { label: 'EUR', value: 'EUR' },
      ],
      threeDOption: null,
      threeDOptions: [
        { label: 'Evet', value: 'true' },
        { label: 'Hayır', value: 'false' },
      ],
      imeiFilter: '',
      pkInvoiceStatusOption: null,
      pkInvoiceStatusOptions: [
        { label: 'Gerekmiyor', value: 'NotRequired' },
        { label: 'Bekliyor', value: 'Pending' },
        { label: 'Gecikmiş', value: 'Overdue' },
        { label: 'Yüklendi', value: 'Uploaded' },
      ],
    }
  }
  const [trackingNumberFilter, setTrackingNumberFilter] = useState('')
  const [filteredList, setFilteredList] = useState<ISuccessFullResponse[]>([])
  const [showFilterRow, setShowFilterRow] = useState(false)
  const [bankSelectOptions, setBankSelectOptions] = useState<ISelectOption[]>([])
  const [bankSelectOption, setBankSelectOption] = useState<any>()
  const [dataCounter, setDataCounter] = useState<number | undefined>(undefined)

  //#region Tarih ve saat ayarları
  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setHours(0)
  inititalStartDate.setMinutes(0)
  inititalStartDate.setSeconds(0)
  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<ISuccessfullState>(intialState)

  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())

  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace(' ', 'T')
  }
  // Klavyeden tarih ve saat girebilmeye imkan veren fonksiyon
  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }
  //#endregion

  const getCompanies = async () => {
    try {
      const companyList: ICompany[] = await getCompanyApi()
      const companiesOptions: ISelectOption[] = companyList.map(company => ({
        label: company.Name,
        value: company.Code.toString(),
      }))
      setState({ companyListOptions: companiesOptions })
    } catch (err) {
      console.log('Fetch Companies Error:', err)
    }
  }

  const getOrderPerm = async () => {
    try {
      const res = await new OrderPermApi({}).checkOrderPerm()
      if (res) {
        setState({ orderBool: res })
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  useEffect(() => {
    getOrderPerm()
    getPosFilters()
    getCompanies()
  }, [])

  const getPosFilters = async () => {
    try {
      const res = await new ListPosDataApi().listPosData()
      const options = [
        { value: 'normal', label: 'Normal POS' },
        ...(res || []).map(x => ({
          value: x.Name,
          label: x.Name,
        })),
      ]
      setState({
        posFilterOptions: options,
      })
    } catch (err: any) {
      console.log(err)
    }
  }

  const getOrderDetail = async (orderNumber: string, orderDealer: string, orderCompanyOption: string) => {
    if (!orderNumber || !orderDealer || !orderCompanyOption)
      return Swal.fire({
        icon: 'error',
        title: 'Bütün alanları doldurunuz',
        showConfirmButton: true,
        allowOutsideClick: false,
      })

    const req: ICardNumberRequest = {
      orderNumber: orderNumber,
      dealer: orderDealer,
      company: orderCompanyOption,
    }
    try {
      const res = await new OrderDetailApi({}).getOrderDetail(req)
      if (res) {
        setState({ orderDetail: res })
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
  }

  // Tablo başlıkları
  const columnDefinitions = [
    { Header: 'İptal Durumu', accessor: 'col0' },
    { Header: 'Şirket', accessor: 'col1' },
    { Header: 'İşlem Tarihi', accessor: 'col2' },
    { Header: 'Banka', accessor: 'col3' },
    {
      Header: 'Tutar', accessor: 'col4', Cell: ({ value }) => {
        if (typeof value === 'number') {
          return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
        return value
      },
    },
    { Header: 'Taksit', accessor: 'col5' },
    { Header: 'Para Birimi', accessor: 'cur' },
    { Header: 'Kur Bilgisi', accessor: 'curData' },
    { Header: 'Ödenen', accessor: 'realPrice' },
    { Header: 'Firma Kodu', accessor: 'col6' },
    { Header: 'Firma Adı', accessor: 'dealerName' },
    { Header: 'Kart İsmi', accessor: 'col7' },
    { Header: 'Kart No', accessor: 'col8' },
    { Header: 'Ödeme Tipi', accessor: 'col9' },
    { Header: 'Kampanya', accessor: 'col10' },
    { Header: 'Vade No', accessor: 'col11' },
    { Header: 'Makbuz No', accessor: 'col12' },
    { Header: 'Sipariş No', accessor: 'col13' },
    { Header: '3D', accessor: 'col14' },
    { Header: 'Komisyon', accessor: 'col15' },
    { Header: 'Personel', accessor: 'col16' },
    { Header: 'IMEI', accessor: 'col17' },
    { Header: 'Fatura', accessor: 'pkInvoice' },
  ]

  const makbuzOlustur = async (order: string, dealer: string, company: string) => {
    Swal.fire({
      icon: 'question',
      title: `${order} için makbuz kaydı oluşturulacaktır. Devam etmeden önce banka hesaplarınızı kontrol etmeyi unutmayın.`,
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed) {
        createReceipt(order, dealer, company)
      }
    })
  }

  /**
   * İptal/geri alma işlemini SON yapan kullanıcı. Etiket Cancelled'a göre değişir:
   * kayıt iptalliyse "İptal eden", değilse (geçmişte iptal edilip geri alınmışsa)
   * "İptali geri alan". Alanlar boşsa hiçbir şey basılmaz — bu, kayıt tutulmaya
   * başlanmadan önce iptal edilmiş eski işlemler demektir.
   */
  const cancelAuditInfo = (item: ISuccessFullResponse) => {
    if (!item.CancelledUserName && !item.CancelledDate) return null

    const label = item.Cancelled ? 'İptal eden' : 'İptali geri alan'
    const who = [item.CancelledUserName, item.CancelledDealerCode?.replace('0000', '')]
      .filter(Boolean)
      .join(' / ')
    const when = item.CancelledDate ? moment(item.CancelledDate).format('DD.MM.YYYY HH:mm') : ''

    return (
      <div style={{ fontSize: '11px', marginTop: '4px', lineHeight: 1.3 }} title={`${label}: ${who} ${when}`}>
        <b>{label}:</b> {who}
        {when && <><br />{when}</>}
      </div>
    )
  }

  const cancelPos = async (order: string, dealer: string, company: string, cancelStatus: boolean) => {
    const req: ICancelPosRequest = {
      DealerCode: dealer,
      OrderNumber: order,
      Company: company
    }

    let text = ''
    if (!cancelStatus) {
      text = `${order} işlemini SAP'den iptal ettiğinizi kaydetmek istiyorsunuz. Yapacağınız işlem ödeme türüne göre yalnızca bayinin harcamalarından işlem tutarını geri alır ve limitlerine geri ekler.`
    }
    else {
      text = `${order} işlemi için iptal kaydını geri almak istiyorsunuz. Yapacağınız işlem ödeme türüne göre yalnızca bayinin harcamalarına eklenen işlem tutarını tekrar düşer ve limitlerinden tekrar eksiltir.`
    }

    Swal.fire({
      icon: 'question',
      title: `${text}`,
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed) {
        props.showLoading()
        const cancelApi: CancelPosApi = new CancelPosApi({})
        await cancelApi.cancelPos(req)
          .then(result => {
            if (result) {
              getSuccessfull()
              Swal.fire({
                icon: 'success',
                title: result,
                showConfirmButton: true,
                allowOutsideClick: false,
              })
            }
            props.hideLoading()
          })
          .catch((err: any) => {
            Swal.fire({
              icon: 'error',
              title: err.description,
              showConfirmButton: true,
              allowOutsideClick: false,
            })
            props.hideLoading()
          })
      }
    })
  }

  const createReceipt = async (order: string, dealer: string, company: string) => {
    let req = {
      Company: company,
      Dealer: dealer,
      Order: order
    }
    props.showLoading()
    const createReceiptApi: CreateReceiptFromSuccessApi = new CreateReceiptFromSuccessApi({})
    await createReceiptApi
      .createReceipt(req)
      .then(result => {
        if (result) {
          getSuccessfull()
          Swal.fire({
            icon: 'success',
            title: result,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
        props.hideLoading()
      })
      .catch((err: any) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  // Peşine Kontrat IMEI faturası: Gerekmiyor / Bekliyor (vade) / Gecikmiş / Görüntüle (imzalı adres)
  const pkInvoiceCell = (item: ISuccessFullResponse) => {
    switch (item.PkInvoiceStatus) {
      case 'NotRequired':
        return 'Gerekmiyor'
      case 'Pending':
        return item.PkInvoiceDueDate
          ? `Bekliyor (vade: ${moment(item.PkInvoiceDueDate).format('DD.MM.YYYY')})`
          : 'Bekliyor'
      case 'Overdue':
        return <span style={{ color: '#c62828', fontWeight: 600 }}>Gecikmiş</span>
      case 'Uploaded':
        return item.PkInvoiceUrl ? (
          <a href={item.PkInvoiceUrl} target='_blank' rel='noopener noreferrer'>
            Görüntüle
          </a>
        ) : (
          'Yüklendi'
        )
      default:
        return ''
    }
  }

  const tableColumns = useMemo(() => columnDefinitions, [])
  // Tablo verileri
  const tableDataAndTotal = useMemo(() => {
    let totalPayInfo = 0
    const tableData = filteredList.map(item => {
      const cleanedPayInfo = item.PayInfo.replace(/\./g, '').replace(',', '.')
      const payInfoValue = parseFloat(cleanedPayInfo)
      const data = {
        col0: item.Cancelled ? (<>
          <IPButton
            text={`İptali Geri Al`}
            style={{ backgroundColor: 'green' }}
            onClick={() =>
              cancelPos(item.OrderNumber, item.DealaerCode, item.Company, item.Cancelled)
            }
          />
          {cancelAuditInfo(item)}
        </>) : (<>
          <IPButton
            text={`İptal Et`}
            onClick={() => {
              Swal.fire({
                title: 'İptal Onayı',
                html: '<b style="color: red;">İptal Etme işlemi yalnızca avantaj ve fırsat ödemeleri için limitleri geri ekler. Cari ödeme ve FÇV2 için yalnızca iptal edildi bilgisini kayıtlı tutar. İşlem iptalini banka paneli üzerinden gerçekleştirmeniz gerekmektedir.</b>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Evet, İptal Et',
                cancelButtonText: 'Vazgeç',
                confirmButtonColor: '#d33'
              }).then((result) => {
                if (result.isConfirmed) {
                  cancelPos(item.OrderNumber, item.DealaerCode, item.Company, item.Cancelled);
                }
              });
            }}
          />
          {cancelAuditInfo(item)}
        </>),
        col1:
          item.Company && item.Company === '1000'
            ? 'IDX'
            : item.Company === '2300'
              ? 'NTX'
              : item.Company === '1200'
                ? 'DPC'
                : item.Company === '1100'
                  ? 'DGT'
                  : '',
        col2: item.ProcessTime && moment(item.ProcessTime).format('DD.MM.YYYY HH:mm:ss'),
        col3: item.Bank,
        col4: parseFloat(item.PayInfo.replaceAll('.', '').replace(',', '.')),
        col5:
          item.PayInstallment && item.PayInstallment === '0'
            ? 'Tek Çekim'
            : item.PayInstallment === '1'
              ? 'Tek Çekim'
              : item.PayInstallment + ' Taksit',
        col6: item.DealaerCode && item.DealaerCode.replace('0000', ''),
        dealerName: item.DealerName,
        col7: item.CardName.toUpperCase(),
        col8: state.orderBool ? (
          <span
            style={{ cursor: 'pointer', color: 'blue' }}
            onClick={() => {
              setState({
                orderShow: true,
                detailTKY: item.OrderNumber,
                detailDealer: item.DealaerCode?.replace('0000', ''),
              })
              getOrderDetail(item.OrderNumber, item.DealaerCode, item.Company)
            }}
          >
            {item.CarNumber}
          </span>
        ) : (
          item.CarNumber
        ),
        col9: item.ProcessType,
        col10: item.PaymentTermsName,
        col11: item.SapSiparisNO,
        col12: item.SapTakipNO ? (
          item.SapTakipNO
        ) : (
          moment().diff(moment(item.ProcessTime), "minutes") >= 5 && (
            <IPButton
              text={`Makbuz Oluştur`}
              onClick={() =>
                makbuzOlustur(item.OrderNumber, item.DealaerCode, item.Company)
              }
            />
          )
        ),

        col13: item.OrderNumber,
        col14: item.is3D ? 'Evet' : 'Hayır',
        col15:
          item.IMEI != null
            ? 'Peşine Kontrat'
            : item.ComissionType === 3
              ? 'Komisyonsuz'
              : item.ComissionType === 2
                ? 'Hariç'
                : item.ComissionType === 1
                  ? 'Dahil'
                  : '',
        col16: item.isMt ? item.UserName : '',
        cur: item.Currency ?? 'TL',
        realPrice: (
          <div style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>{item.RealPrice ?? '-'}</div>
        ),
        curData: item.CurrencyData ? (
          <div style={{ display: 'flex', textAlign: 'center' }}>
            {item.Currency === 'USD' && (
              <>
                <span style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>
                  USD:
                  {item.CurrencyData.Usd ? parseFloat(item.CurrencyData.Usd.replace(',', '.')).toFixed(4) : '0.0000'}
                </span>
                <br />
              </>
            )}

            {item.Currency === 'EUR' && (
              <span style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>
                EUR:{item.CurrencyData.Eur ? parseFloat(item.CurrencyData.Eur.replace(',', '.')).toFixed(4) : '0.0000'}
              </span>
            )}

            {item.Currency === 'TL' && (
              <>
                <span style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>-</span>
                <br />
              </>
            )}
          </div>
        ) : (
          <span style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>-</span>
        ),
        col17: item.IMEI,
        pkInvoice: pkInvoiceCell(item),
      }
      // if (!isNaN(+item.PayInfo)) {
      //   totalPayInfo += parseFloat(item.PayInfo);
      // }
      if (!isNaN(payInfoValue)) {
        totalPayInfo += payInfoValue
      }
      return data
    })
    return {
      tableData,
      totalPayInfo,
    }
  }, [filteredList])

  //#region Tüm, başarılı ve başarısız işlem sayılarını veren tablo
  const successfulReceipt = useMemo(() => {
    const totalReceipt = filteredList.length
    const successfulReceipt = filteredList.reduce(
      (acc, x) => acc + (x.SapTakipNO && x.SapTakipNO.length > 0 ? 1 : 0),
      0
    )
    const unsuccessfulReceipt = totalReceipt - successfulReceipt

    return [
      { label: 'Makbuzu Oluşan Sayısı', count: successfulReceipt },
      { label: 'Makbuzu Oluşmayan Sayısı', count: unsuccessfulReceipt },
      { label: 'Toplam İşlem Sayısı', count: totalReceipt },
    ]
  }, [filteredList])
  //#endregion

  // Api'den seçilen değerlere göre verileri aldığımız fonksiyon
  const getSuccessfull = async () => {
    if (!startDate || !endDate) {
      Swal.fire({
        icon: 'error',
        title: 'Lütfen tarih giriniz',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
      return
    }
    const uniqueBankLabels = {}
    const req: ISuccessFullRequest = {
      Company: state.companyListFirstOption?.value,
      OrderNumber: state.tkyNumber,
      DealerCode: state.dealerCode.length > 5 ? state.dealerCode.padStart(10, '0') : state.dealerCode,
      StartDate: startDate && (getDateByTimezoneOffset(startDate) as any),
      EndDate: endDate && (getDateByTimezoneOffset(endDate) as any),
      Type: state.typeOption?.value,
    }
    props.showLoading()
    const getSuccessFullApi: GetSuccessFullApi = new GetSuccessFullApi({})
    await getSuccessFullApi
      .getSuccessFull(req)
      .then(result => {
        if (result) {
          setBankSelectOptions(
            result
              .map(x => ({
                // value, benzersiz olmalı: BankNo birden fazla banka için aynı (null/boş) gelebildiğinden
                // react-select tek birini seçince aynı value'ya sahip tüm seçenekleri seçili gösteriyordu.
                // Süzme zaten label üzerinden yapıldığı için value olarak da label kullanıyoruz.
                value: x.Bank.toUpperCase(),
                label: x.Bank.toUpperCase(),
              }))
              .filter(option => {
                if (!uniqueBankLabels[option.label]) {
                  uniqueBankLabels[option.label] = true
                  return true
                }
                return false
              })
          )
          setState({ successfulData: result })
          setFilteredList(result)
          setDataCounter(result.length)
          setShowFilterRow(true)
        }
        props.hideLoading()
      })
      .catch((err: any) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  //#region Detaylı Süzme fonksiyonu
  const filterList = () => {
    const filterConditions: ((item: ISuccessFullResponse) => boolean)[] = []

    if (bankSelectOption && trackingNumberFilter.length < 10) {
      filterConditions.push(b => b.Bank.toUpperCase() === bankSelectOption.label)
    }

    if (trackingNumberFilter) {
      const validLengths = [10, 13, 14]

      if (validLengths.includes(trackingNumberFilter.length)) {
        setBankSelectOption(null)
        state.companyListOption = null
      }
      filterConditions.push(x => x.OrderNumber.includes(trackingNumberFilter.toUpperCase()))
    }

    if (state.companyListOption) {
      filterConditions.push(c => c.Company === state.companyListOption.value)
    }

    if (state.mtOption) {
      filterConditions.push(
        c => c.isMt === (state.mtOption.value === 1 ? true : state.mtOption.value === 2 ? false : '')
      )
    }

    // Sadece İptal Süzme
    if (state.cancelFilterCheckbox) {
      filterConditions.push(x => {
        return x.Cancelled === true
      })
    }

    // Sadece Vodafone Süzme
    if (state.vodafoneFilterCheckbox) {
      filterConditions.push(x => {
        return x.IMEI != null
      })
    }

    // Sadece Makbuzsuz Süzme
    if (state.additionalFilter) {
      filterConditions.push(x => {
        return x.SapTakipNO?.length < 1 || x.SapTakipNO === null
      })
    }

    // POS adı ile Süzme
    if (state.posFilterOption?.value) {
      if (state.posFilterOption.value === 'normal') {
        // Normal POS: API'den gelen poslar haricinde filtrele
        const apiPosList = state.posFilterOptions
          .filter(p => p.value !== 'normal')
          .map(p => p.value as string)
        filterConditions.push(x => {
          return !apiPosList.some(pos => x.Bank?.toLocaleLowerCase('tr-TR').includes(pos.toLocaleLowerCase('tr-TR')))
        })
      } else {
        // Diğer poslar: normalde olduğu gibi filtrele
        const selectedPos = String(state.posFilterOption.value).toLocaleLowerCase('tr-TR')
        filterConditions.push(x => {
          return x.Bank?.toLocaleLowerCase('tr-TR').includes(selectedPos)
        })
      }
    }

    // Kur Tipi Süzme
    if (state.currencyOption) {
      filterConditions.push(x => {
        return (x.Currency ?? 'TL') === state.currencyOption.value
      })
    }

    // 3D Süzme
    if (state.threeDOption) {
      filterConditions.push(x => {
        return x.is3D === (state.threeDOption.value === 'true')
      })
    }

    // IMEI Süzme
    if (state.imeiFilter) {
      filterConditions.push(x => {
        return x.IMEI != null && x.IMEI.toUpperCase().includes(state.imeiFilter.toUpperCase())
      })
    }

    // Fatura durumu süzme (IMEI'siz satırların durumu boştur, seçim yapılınca düşer)
    if (state.pkInvoiceStatusOption?.value) {
      filterConditions.push(x => x.PkInvoiceStatus === state.pkInvoiceStatusOption.value)
    }

    let filteredData: ISuccessFullResponse[] = state.successfulData

    if (filterConditions.length > 0) {
      filteredData = filteredData.filter(item => {
        return filterConditions.every(condition => condition(item))
      })
    }
    setDataCounter(filteredData.length)
    setFilteredList(filteredData)
  }
  //#endregion

  //#region Excel'e aktarma
  const excelButton = async () => {
    try {
      if (filteredList) {
        const data: any[] = []
        if (filteredList.length > 0) {
          filteredList.map(item => {
            return data.push({
              Şirket:
                item.Company && item.Company === '1000'
                  ? 'IDX'
                  : item.Company === '2300'
                    ? 'NTX'
                    : item.Company === '1200'
                      ? 'DPC'
                      : item.Company === '1100'
                        ? 'DGT'
                        : '',
              'İşlem Tarihi': item.ProcessTime && moment(item.ProcessTime).format('DD.MM.YYYY HH:mm:ss'),
              Banka: item.Bank,
              Tutar: parseFloat(item.PayInfo.replaceAll('.', '').replace(',', '.')),
              Taksit:
                item.PayInstallment && item.PayInstallment === '0'
                  ? 'Tek Çekim'
                  : item.PayInstallment === '1'
                    ? 'Tek Çekim'
                    : item.PayInstallment + ' Taksit',
              'Para Birimi': item.Currency ?? 'TL',
              'Kur Bilgisi': item.CurrencyData
                ? item.Currency === 'USD'
                  ? `USD: ${item.CurrencyData.Usd ? parseFloat(item.CurrencyData.Usd.replace(',', '.')).toFixed(4) : '0.0000'
                  }`
                  : item.Currency === 'EUR'
                    ? `EUR: ${item.CurrencyData.Eur ? parseFloat(item.CurrencyData.Eur.replace(',', '.')).toFixed(4) : '0.0000'
                    }`
                    : '-'
                : '-',
              'Ödenen Tutar': item.RealPrice ?? '-',
              'Firma Kodu': item.DealaerCode && item.DealaerCode.replace('0000', ''),
              'Firma Adı': item.DealerName,
              'Kart İsmi': item.CardName.toUpperCase(),
              'Kart No': item.CarNumber,
              'Ödeme Tipi': item.ProcessType,
              'Kampanya': item.PaymentTermsName,
              'Vade No': item.SapSiparisNO,
              'Makbuz No': item.SapTakipNO,
              'Sipariş No': item.OrderNumber,
              '3D': item.is3D ? 'Evet' : 'Hayır',
              Komisyon:
                item.IMEI != null
                  ? 'Peşine Kontrat'
                  : item.ComissionType === 3
                    ? 'Komisyonsuz'
                    : item.ComissionType === 2
                      ? 'Hariç'
                      : item.ComissionType === 1
                        ? 'Dahil'
                        : '',
              Personel: item.isMt ? item.UserName : '',
              IMEI: item.IMEI
            })
          })
          if (tableDataAndTotal && tableDataAndTotal.totalPayInfo) {
            const totalPayInfoFormatted =
              tableDataAndTotal.totalPayInfo
                .toFixed(2)
                .replace('.', ',')
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ₺'
            data.push({
              Şirket: '',
              'İşlem Tarihi': '',
              Banka: '',
              Tutar: '',
              Taksit: '',
              'Para Birimi': '',
              'Kur Bilgisi': '',
              Ödenen: '',
              'Firma Kodu': '',
              'Firma Adı': '',
              'Kart İsmi': '',
              'Kart No': '',
              'Ödeme Tipi': '',
              'Kampanya': '',
              'Vade No': '',
              'Makbuz No': '',
              'Sipariş No': '',
              '3D': '',
              Komisyon: '',
              Personel: '',
              IMEI: '',
              'Toplam Tutar': totalPayInfoFormatted,
            })
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSX(data, 'Başarılı İşlem Raporu')
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }
  //#endregion

  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <span className='h4 mb-0'>{t('pages.admin.CreditCardOperation.Successful.header')}</span>
            <div className='d-flex align-items-center'>
              <span>Excel: </span>
              <button
                type='button'
                style={{
                  border: '1px solid #2e7d32',
                  borderRadius: 0,
                  width: '29px',
                  height: '29px',
                  backgroundColor: 'white',
                  margin: '0 10px',
                }}
                onClick={excelButton}
                className='btn text-capitalize background-white-important d-flex align-items-center'
              >
                <i
                  className='fas fa-file-excel'
                  style={{
                    marginLeft: '-6px',
                    fontSize: '18px',
                    color: '#2e7d32',
                  }}
                ></i>
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div
              className='main-filter-form'
              style={{
                border: '2px solid #dc3545',
                borderRadius: '8px',
                padding: '20px',
                backgroundColor: '#fff5f5',
                marginBottom: '20px',
              }}
            >
              <h6 style={{ marginBottom: '20px', color: '#dc3545', fontWeight: 'bold' }}>Ana Arama Kriterleri</h6>

              <div className='row g-3'>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Başlangıç Tarihi
                  </label>
                  <InputCampaign
                    type='datetime-local'
                    id='StartDate'
                    name='StartDate'
                    label={''}
                    value={startDate && toDateTimeLocal(startDate)}
                    onChange={e => getDate(e.target.value, 'Start')}
                    isActive
                  />
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Bitiş Tarihi
                  </label>
                  <InputCampaign
                    type='datetime-local'
                    id='EndDate'
                    name='EndDate'
                    label={''}
                    value={endDate && toDateTimeLocal(endDate)}
                    onChange={e => getDate(e.target.value, 'End')}
                    isActive
                  />
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Bayi Kodu
                  </label>
                  <IPInput
                    type='text'
                    className='form-control'
                    placeholder='Bayi kodu giriniz'
                    onChange={e => setState({ dealerCode: String(e.target.value) })}
                    value={state.dealerCode && state.dealerCode}
                  />
                  <small className='text-muted'>* Boş bırakırsanız hepsi</small>
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    İşlem No (Sipariş/Makbuz/Vade Farkı)
                  </label>
                  <IPInput
                    type='text'
                    className='form-control'
                    placeholder='İşlem numarası giriniz'
                    onChange={e => setState({ tkyNumber: String(e.target.value) })}
                    value={state.tkyNumber && state.tkyNumber}
                  />
                  <small className='text-muted'>* Boş bırakırsanız hepsi</small>
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Şirket
                  </label>
                  <IPSelectBox
                    isClearable
                    placeholder='Şirket seçiniz'
                    options={state.companyListOptions}
                    value={state.companyListFirstOption}
                    onChangeSingle={option => {
                      setState({ companyListFirstOption: option })
                    }}
                  />
                  <small className='text-muted'>* Boş bırakırsanız hepsi</small>
                </div>
                <div className='col-md-2'>
                  <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500', color: '#495057' }}>
                    Ödeme Tipi
                  </label>
                  <IPSelectBox
                    isClearable
                    placeholder='Ödeme tipi seçiniz'
                    options={state.typeOptions}
                    value={state.typeOption}
                    onChangeSingle={option => {
                      setState({ typeOption: option })
                    }}
                  />
                  <small className='text-muted'>* Boş bırakırsanız hepsi</small>
                </div>
              </div>

              <div className='row mt-4 justify-content-center'>
                <div className='col-3 text-center'>
                  <IPButton
                    text='📊 Verileri Göster'
                    className='btn btn-danger px-3 py-1'
                    onClick={getSuccessfull}
                    style={{
                      borderRadius: '6px',
                      fontWeight: '500',
                      fontSize: '0.9rem',
                      minWidth: '120px',
                    }}
                  />
                </div>
              </div>
            </div>

            {showFilterRow && (
              <>
                <div
                  className='detailFilter'
                  style={{
                    marginTop: '15px',
                    border: '2px solid #9c9cf1',
                    borderRadius: '8px',
                    padding: '15px',
                    backgroundColor: '#f8f9fa',
                    position: 'relative',
                  }}
                >
                  <div className='d-flex justify-content-between align-items-start'>
                    <h6 style={{ marginBottom: '15px', color: '#495057', fontWeight: 'bold' }}>Detaylı Filtreleme</h6>

                    {/* Checkbox'lar sağ üstte */}
                    <div className='d-flex gap-4'>
                      <div className='form-check'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          id='cancelCheckBox'
                          checked={state.cancelFilterCheckbox}
                          onChange={e => {
                            setState({ cancelFilterCheckbox: e.target.checked })
                          }}
                          style={{ transform: 'scale(1.2)' }}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='cancelCheckBox'
                          style={{ fontSize: '0.95rem', marginLeft: '8px', fontWeight: '500' }}
                        >
                          İptal Edilmiş
                        </label>
                      </div>
                      <div className='form-check'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          id='vodafoneFilterCheckbox'
                          checked={state.vodafoneFilterCheckbox}
                          onChange={e => {
                            setState({ vodafoneFilterCheckbox: e.target.checked })
                          }}
                          style={{ transform: 'scale(1.2)' }}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='vodafoneFilterCheckbox'
                          style={{ fontSize: '0.95rem', marginLeft: '8px', fontWeight: '500' }}
                        >
                          Sadece Peşine Kontrat
                        </label>
                      </div>
                      <div className='form-check'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          id='additionalFilterCheckbox'
                          checked={state.additionalFilter}
                          onChange={e => {
                            setState({ additionalFilter: e.target.checked })
                          }}
                          style={{ transform: 'scale(1.2)' }}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='additionalFilterCheckbox'
                          style={{ fontSize: '0.95rem', marginLeft: '8px', fontWeight: '500' }}
                        >
                          Sadece Makbuzsuz
                        </label>
                      </div>
                      <div style={{ minWidth: '220px' }}>
                        <IPSelectBox
                          isClearable
                          placeholder='POS Seçiniz'
                          options={state.posFilterOptions}
                          value={state.posFilterOption ? state.posFilterOption : null}
                          onChangeSingle={option => {
                            setState({ posFilterOption: option })
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* İlk Satır - Dropdown Filtreler */}
                  <div className='row mb-3'>
                    <div className='col-md-2'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                        Banka
                      </label>
                      <IPSelectBox
                        isClearable
                        placeholder='Banka Seçiniz'
                        options={bankSelectOptions}
                        value={bankSelectOption}
                        onChangeSingle={option => {
                          setBankSelectOption(option)
                        }}
                      />
                    </div>
                    <div className='col-md-2'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                        Şirket
                      </label>
                      <IPSelectBox
                        isClearable
                        placeholder='Şirket Seçiniz'
                        options={state.companyListOptions}
                        value={state.companyListOption}
                        onChangeSingle={option => {
                          setState({ companyListOption: option })
                        }}
                      />
                    </div>
                    <div className='col-md-1'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                        Ödeyen Kişi
                      </label>
                      <IPSelectBox
                        isClearable
                        placeholder='Kişi Seçiniz'
                        options={state.mtOptions}
                        value={state.mtOption}
                        onChangeSingle={option => {
                          setState({ mtOption: option })
                        }}
                      />
                    </div>
                    <div className='col-md-1'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                        Kur Tipi
                      </label>
                      <IPSelectBox
                        isClearable
                        placeholder='Kur Seçiniz'
                        options={state.currencyOptions}
                        value={state.currencyOption}
                        onChangeSingle={option => {
                          setState({ currencyOption: option })
                        }}
                      />
                    </div>
                    <div className='col-md-1'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                        3D Durumu
                      </label>
                      <IPSelectBox
                        isClearable
                        placeholder='3D Seçiniz'
                        options={state.threeDOptions}
                        value={state.threeDOption}
                        onChangeSingle={option => {
                          setState({ threeDOption: option })
                        }}
                      />
                    </div>
                    <div className='col-md-2'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                        IMEI
                      </label>
                      <IPInput
                        type='text'
                        className='form-control'
                        placeholder='IMEI giriniz'
                        onChange={e => setState({ imeiFilter: e.target.value })}
                        value={state.imeiFilter}
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            e.preventDefault()
                            filterList()
                          }
                        }}
                      />
                    </div>
                    <div className='col-md-2'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                        Fatura Durumu
                      </label>
                      <IPSelectBox
                        isClearable
                        placeholder='Fatura Durumu Seçiniz'
                        options={state.pkInvoiceStatusOptions}
                        value={state.pkInvoiceStatusOption}
                        onChangeSingle={option => {
                          setState({ pkInvoiceStatusOption: option })
                        }}
                      />
                    </div>
                    <div className='col-md-2'>
                      <label className='form-label' style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                        Pos Takip No
                      </label>
                      <IPInput
                        type='text'
                        className='form-control'
                        placeholder='Takip numarası giriniz'
                        onChange={e => setTrackingNumberFilter(e.target.value)}
                        value={trackingNumberFilter}
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            e.preventDefault()
                            filterList()
                          }
                        }}
                      />
                    </div>
                  </div>

                  {/* Buton kendi satırında ortalanmış */}
                  <div className='row justify-content-center'>
                    <div className='col-md-3'>
                      <IPButton
                        type='button'
                        className='btn btn-primary px-4 py-2'
                        text='🔍 Detaylı Süz'
                        onClick={filterList}
                        style={{
                          height: '42px',
                          borderRadius: '6px',
                          fontWeight: '500',
                          fontSize: '0.95rem',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* UseMemo'dan gelen verilerin tablosu */}
            <div className='m-4'>
              <b style={{ color: 'red' }}>İptal Etme işlemi yalnızca avantaj ve fırsat ödemeleri için limitleri geri ekler. Cari ödeme ve FÇV2 için yalnızca iptal edildi bilgisini kayıtlı tutar.</b><br></br>
              <b style={{ color: 'red' }}>İşlem iptalini banka paneli üzerinden gerçekleştirmeniz gerekmektedir.</b>
              <br></br>
              <p></p>
              <Table
                columns={tableColumns}
                data={tableDataAndTotal.tableData}
                currentPage={0}
                headerName={`İşlem Tarihi Aralığı: ${new Date(startDate).toLocaleDateString()} - ${new Date(
                  endDate
                ).toLocaleDateString()} ---TOPLAM İŞLEM SAYISI: ${dataCounter}---TOPLAM TUTAR: ${tableDataAndTotal.totalPayInfo
                  .toFixed(2)
                  .replace('.', ',')
                  .replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ₺'
                  }`}
                columnCount={23}
                backgroundColor='red'
                color='white'
              />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {/* UseMemo'dan gelen verilerin tablosu */}
            <table className='table' style={{ width: '60%', tableLayout: 'fixed' }}>
              <colgroup>
                {successfulReceipt.map((_, index) => (
                  <col key={index} style={{ width: '33%' }} />
                ))}
              </colgroup>
              <thead>
                <tr>
                  {successfulReceipt.map((data, index) => (
                    <th key={index} style={{ whiteSpace: 'nowrap', textAlign: 'center' }} scope='col'>
                      {data.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {successfulReceipt.map((data, index) => (
                    <td
                      key={index}
                      style={{
                        textAlign: 'center',
                        color:
                          data.label === 'Makbuzu Oluşmayan Sayısı'
                            ? 'red'
                            : data.label === 'Makbuzu Oluşan Sayısı'
                              ? 'green'
                              : 'blue',
                        fontWeight: 'bold',
                      }}
                    >
                      {data.count}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <IPModal
        show={state.orderShow}
        onClose={() => setState({ orderShow: false, orderDetail: undefined })}
        hideConfirm={true}
        width={500}
        title={`Kart Bilgileri - ${state.detailTKY} - ${state.detailDealer}`}
      >
        <div className='card-body'>
          {!state.orderDetail?.errorMessage && (
            <>
              <h5>Kart Numarası: {state.orderDetail?.cardNumber}</h5>
              <h5>
                SKT: {state.orderDetail?.cardExpiryDateYear} / {state.orderDetail?.cardExpiryDateMonth}{' '}
                {state.orderDetail?.cardExpiryDate && '-'} {state.orderDetail?.cardExpiryDate}
              </h5>
            </>
          )}
          {state.orderDetail?.errorMessage && <h5>{state.orderDetail?.errorMessage}</h5>}
          <hr></hr>
        </div>
      </IPModal>
    </div>
  )
}
export default componentWithContext(Successful)
